import React, { useState } from 'react';
import '../styles/AboutSection.css';
import heroFrame from '../assets/hero_frame-1.png';

const AboutSection = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const videoUrl = '';

  return (
    <div id="about-industry-max" className="about-section">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h1 id="about-title-html" className="about-title">ABOUT INDUSTRY MAX</h1>
            <div className="about-description">
              <p>At Industry Max, our work focuses on <strong>computer systems</strong> and <strong>communication equipment software trading</strong>, providing innovative IT solutions that help organizations grow and perform efficiently.</p>
              <p>We are also engaged in the <strong>monitoring and remote monitoring</strong> of electronic security alarm systems, including <strong>burglar and fire alarms</strong>, supported by reliable installation, regular maintenance, and professional technical services.</p>
              <p>We are licensed under the <strong><span style={{color: '#173994'}}>Meydan Free Zone Authority</span></strong> and operate with a clear vision: to provide businesses with <strong>reliable, scalable, and secure technology infrastructure</strong>.</p>
            </div>
            <div className="about-button-wrapper">
              <a className="about-button" href="/e-catalog/" ondragstart="return false">
                <span className="button-content-wrapper">
                  <span className="button-text">More about Industry Max</span>
                </span>
              </a>
            </div>
          </div>
          <div className="about-visual">
            <div className="about-image-container">
              <img 
                src={heroFrame} 
                alt="Industry Max Technology Solutions" 
                className="about-image"
              />
              {!isVideoOpen && (
                <>
                  <div className="image-overlay">
                    <div className="overlay-text-large">Industry Max</div>
                    <div className="overlay-text-small">Innovative IT Solutions & Security Systems</div>
                  </div>
                  <div
                    className="play-button"
                    onClick={() => setIsVideoOpen(true)}
                    role="button"
                    aria-label="Play video"
                  >
                    <div className="play-icon">▶</div>
                  </div>
                </>
              )}
              {isVideoOpen && (
                <div className="inline-video-wrapper">
                  <iframe
                    src={videoUrl}
                    title="About Industry Max Video"
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
